// src/hooks/useNotificationPrefs.js
import { useState, useEffect, useCallback } from "react";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

// All supported notification event types
export const NOTIF_EVENT_TYPES = [
  { key: "task_assigned",       label: "Task Assigned to You" },
  { key: "post_status_changed", label: "Your Log Status Changed" },
  { key: "comment_on_post",     label: "New Comment on Your Log" },
  { key: "comment_mention",     label: "@Mention in a Comment" },
  { key: "systemic_alert",      label: "Systemic Alert Detected" },
  { key: "draft_task_created",  label: "Draft Task Awaiting Approval" },
  { key: "task_completed",      label: "Task Linked to Your Log Completed" },
];

// Default preference for all event types
const DEFAULT_PREF = "all"; // "all" | "in-app" | "off"

export function useNotificationPrefs(uid) {
  const [prefs, setPrefs] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!uid) return;
    setLoading(true);
    return onSnapshot(
      doc(db, "users", uid),
      (snap) => {
        setPrefs(snap.exists() ? (snap.data().notifPrefs || {}) : {});
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, [uid]);

  const getPref = useCallback((eventType) => {
    return prefs[eventType] ?? DEFAULT_PREF;
  }, [prefs]);

  const setPref = useCallback(async (eventType, value) => {
    if (!uid) return;
    await updateDoc(doc(db, "users", uid), {
      [`notifPrefs.${eventType}`]: value,
    });
  }, [uid]);

  return { prefs, loading, getPref, setPref };
}
